require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-malvern-apartments.json") })
        }
      }, "path---project-malvern-apartments");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-malvern-apartments!./.cache/json/project-malvern-apartments.json
// module id = 574
// module chunks = 231608221292675